import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from '../styles'

const renderImageError = (className) => (
  <div css={styles.error} className={className}>
    <FontAwesomeIcon css={styles.errorIcon} icon="times" size="lg" />
  </div>
)

export default renderImageError
